module.exports = __webpack_public_path__ + "images/emoji/video_camera.e405722afb8ce5181403.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/video_camera.png
// module id = 0YHk
// module chunks = 1